export default {
    app: {
        name: 'Forecaster',
        title: 'Forecaster',
        loading: 'Laden...',
        error: 'Ein Fehler ist aufgetreten.',
        saved: 'Gespeichert',
        save: 'Speichern',
    },
    home: {
        welcome: 'Willkommen bei Forecaster!',
        upcomingRain: 'Bevorstehender Regen',
        searchLocation: 'Standort suchen',
        loadingData: 'Wetterdaten werden geladen...',
        findingLocation: 'Ihr Standort wird gesucht...',
        geolocationError: 'Aktueller Standort konnte nicht abgerufen werden. Bitte aktivieren Sie die Ortungsdienste oder suchen Sie nach einem Standort.',
        offlineError: 'Sie scheinen offline zu sein. Bitte überprüfen Sie Ihre Internetverbindung.',
        serverError: 'Es gab ein Problem bei der Verbindung zu unserem Server. Bitte versuchen Sie es später noch einmal.',
        forecastUnavailableError: 'Für diesen Standort ist derzeit keine aktuelle Vorhersage verfügbar. Bitte versuchen Sie es später erneut.',
        currentLocation: 'Aktueller Standort',
        fetchError: 'Wetterdaten konnten nicht geladen werden. Bitte versuchen Sie es später noch einmal.',
        retry: 'Wiederholen',
        byMetNo: 'Bereitgestellt von YR.no',
        byMeteoFrance: 'Bereitgestellt von Météo-France',
        byAppleWeather: 'Bereitgestellt von {appleIcon} Weather',
        byGoogleWeather: 'Bereitgestellt von Google Weather',
        validUntil: 'Gültig bis {time}',
        loadedAt: 'Geladen um {time}',
        currently: 'Aktuell',
        thisWeek: 'Diese Woche',
        today: 'Heute',
        tomorrow: 'Morgen',
        geolocationErrorGeneric: 'Beim Versuch, Ihren Standort zu ermitteln, ist ein Fehler aufgetreten.',
        geolocationPermissionDenied: 'Der Zugriff auf den Standort wurde verweigert. Bitte erlauben Sie die Standortfreigabe in Ihren Browsereinstellungen, um fortzufahren.',
        geolocationPositionUnavailable: 'Wir konnten Ihren Standort nicht bestimmen. Dies kann auf ein schlechtes Signal oder deaktivierte Ortungsdienste zurückzuführen sein.',
        geolocationTimeout: 'Es dauert zu lange, Ihren Standort zu finden. Bitte versuchen Sie es erneut oder überprüfen Sie Ihre Verbindung.',
        geolocationUnsupported: 'Standort ist in diesem Browser oder Kontext nicht verfügbar. Bitte verwenden Sie HTTPS oder suchen Sie nach einem Ort.',
        geolocationPromptRequired: 'Tippen Sie auf "Wiederholen", um den Standortzugriff zu erlauben und fortzufahren.',
        providerError: 'Daten von {providerName} konnten nicht geladen werden. Möglicherweise liegen bei ihnen Probleme vor. Bitte versuchen Sie es später noch einmal.'
    },
    units: {
        precipitation: {
            mm: '{value} mm',
            in: '{value} in',
        },
    },
    drawer: {
        currentLocation: 'Aktueller Standort',
        starredLocations: 'Markierte Orte',
        starToSave: 'Markieren Sie einen Ort, um ihn hier zu speichern.',
        settings: 'Einstellungen',
        colorGuide: 'Legende',
        feedback: 'Feedback',
        helpTranslate: 'Bei der Übersetzung helfen',
    },
    colorGuide: {
        title: 'Legende',
        clear: 'Klar',
        clear_explanation: 'Es ist kein Niederschlag vorhergesagt und weniger als 25% des Himmels wird von Wolken bedeckt sein.',
        partly_cloudy: 'Leicht bewölkt',
        partly_cloudy_explanation: '25% bis 75% des Himmels werden von Wolken bedeckt sein. Es ist kein Niederschlag vorhergesagt.',
        cloudy: 'Bewölkt',
        cloudy_explanation: 'Mehr als 75% des Himmels werden von Wolken bedeckt sein. Es ist kein Niederschlag vorhergesagt.',
        scattered_rain: 'Vereinzelt Regen',
        scattered_rain_explanation: 'Regen in deiner Umgebung vorhergesagt. Es ist jedoch unsicher, ob es deinen genauen Standort treffen wird.',
        rain: 'Regen',
        rain_explanation: 'Hohe Regenwahrscheinlichkeit vorhergesagt.',
        scattered_snow: 'Vereinzelt Schnee',
        scattered_snow_explanation: 'Schnee in deiner Umgebung vorhergesagt. Wir sind jedoch unsicher, ob es deinen genauen Standort treffen wird.',
        snow: 'Schnee',
        snow_explanation: 'Hohe Wahrscheinlichkeit für Schneefall vorhergesagt.',
    },
    settings: {
        title: 'Einstellungen',
        wind_speed_units_default: 'kmh',
        temperature_units_default: 'celsius',
        night_mode_default: 'system',
        units: 'Einheiten',
        temperature_units: 'Temperatur',
        wind_speed_units: 'Windgeschwindigkeit',
        precipitation_units: 'Niederschlag',
        forecast: 'Vorhersage',
        hide_early_morning: 'Frühe Morgenstunden ausblenden',
        hide_early_morning_explanation: 'Zeigt das Wetter ab 5 Uhr morgens anstatt der vollen 24 Stunden',
        appearance: 'Erscheinungsbild',
        theme: 'Thema',
        show_minMax: 'Min/Max Temperaturen anzeigen',
        show_minMax_summary: 'Tägliche Min/Max-Temperaturen neben den Regen- und Wolkeninformationen anzeigen',
        auto_expand_today: 'Heutige Vorhersage automatisch erweitern',
        about: 'Über',
        privacy_policy: 'Datenschutz-Bestimmungen',
        terms_of_service: 'Nutzungsbedingungen',
        provider: 'Anbieter',
        data_source: 'Datenquelle',
        language: 'Sprache',
        unit_selection: {
            celsius: 'Celsius',
            fahrenheit: 'Fahrenheit',
        },
        wind_speed_unit_selection: {
            mph: 'mph',
            knots: 'Knoten',
            kmh: 'km/h',
            ms: 'm/s',
            beaufort: 'Beaufort-Skala',
        },
        precipitation_unit_selection: {
            mm: 'mm',
            inches: 'Zoll',
        },
        night_mode_options: {
            system: 'Systemstandard',
            light: 'Hell',
            dark: 'Dunkel',
        },
        data_source_options: {
            auto: 'Automatisch',
            metno: 'YR.no',
            meteofrance: 'MeteoFrance',
            appleweather: 'Apple Weather',
            googleweather: 'Google Weather',
        },
        language_selection: {
            en: 'English',
            de: 'Deutsch',
            es: 'Español',
            fr: 'Français',
            it: 'Italienisch',
        }
    },
    provider_modal: {
        title: 'Wählen Sie Ihre Wetterquelle',
        close_modal: 'Anbieterauswahl schließen',
        cancel: 'Abbrechen',
        save: 'Speichern',
        metno_desc: 'Zuverlässige globale Vorhersagen des norwegischen Meteorologischen Instituts.',
        meteofrance_desc: 'Detaillierte, hochauflösende Vorhersagen für Frankreich.',
        appleweather_desc: 'Genaue, hochauflösende Daten von Apple Weather.',
        googleweather_desc: 'Hochwertige globale Vorhersagen von Google.',
        auto_desc: 'Lassen Sie die App automatisch die beste Quelle für Ihren Standort auswählen.',
    },
    searchModal: {
        searchForLocation: 'Suche nach einem Ort...',
        placeholder: 'Suche nach einem Ort',
        closeModal: 'Suchmodal schließen',
        googleMapsError: 'Fehler beim Laden der Google Maps Places-Bibliothek:',
        googleMapsNotLoaded: 'Google Maps JavaScript API-Bibliothek nicht geladen.',
        placesLibraryError: 'Orte-Bibliothek nicht vollständig geladen oder Sitzungstoken fehlt.',
        fetchPredictionsError: 'Fehler beim Abrufen von Ortsvorhersagen:',
        fetchDetailsError: 'Fehler beim Abrufen von Ortsdetails:',
        noInput: 'Beginnen Sie mit der Eingabe, um nach Orten zu suchen.',
        noResults: 'Keine Ergebnisse gefunden.',
        noRecentlyViewed: 'Keine kürzlich angesehenen.',
        searchUnavailable: 'Die Suche ist nicht verfügbar, da Google-Dienste von diesem Browser oder Ihrer Konfiguration blockiert werden.',
        searching: 'Suchen...',
        recentlyViewed: 'Zuletzt angesehen',
    },
    minutelyTimeline: {
        now: 'Jetzt',
        minutes: '{minutes}',
        minutesWithUnit: '{minutes} min',
    },
    upcomingRain: {
        maxIntensity: 'Stark',
        midIntensity: 'Mäßig',
        minIntensity: 'Leicht',
    },
    weeklyForecast: {
        rainCloud: 'Regen & Wolken',
        temperature: 'Temperatur',
        wind: 'Wind',
    },
    feedback: {
        title: 'Feedback willkommen',
        message: 'Dein Feedback hilft mir, Forecaster zu verbessern. Bitte lass mich wissen, was du denkst!',
        featureIdeas: 'Hast du eine Idee für eine Funktion? Bitte teile sie mir mit.',
        contactUs: 'Du kannst mich erreichen unter',
        send: 'Feedback senden',
    },
    forecastInfo: {
        details: 'Vorhersageinformationen',
        explanation: 'Wettervorhersagen werden von unseren Anbietern regelmäßig aktualisiert.',
        computed: 'Vom Anbieter generiert',
        expires: 'Neue Vorhersage erwartet',
        loaded: 'Heruntergeladen',
        close: 'Schließen',
    }
};
